import { render, staticRenderFns } from "./ContractAttachments.yaml?vue&type=template&id=6c7340b2&component"
import script from "./ContractAttachments.yaml?vue&type=script&lang=ts&component"
export * from "./ContractAttachments.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports